const APP_ENV = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_TIME_OUT: Number(process.env.REACT_APP_API_TIME_OUT) || 30000,
  WS_BASE_URL: process.env.REACT_APP_WS_BASE_URL,
  WS_RETRY_ATTEMPT: Number(process.env.REACT_APP_WS_RETRY_ATTEMPT) || 25,
  WS_PING_INTERVAL: Number(process.env.REACT_APP_WS_PING_INTERVAL) || 60000,
  SHIFT_BASE_DATE: process.env.REACT_SHIFT_BASE_DATE || '2021-07-04T00:00:00',
  MAXIMUM_SHIFT_LENGTH_HR:
    Number(process.env.REACT_MAXIMUM_SHIFT_LENGTH_HR) || 12,

  /**************** AUTHENTICATION SECRETS ***********************/
  OKTA_CLIENT_ID: process.env.REACT_APP_OKTA_CLIENT_ID || '',
  OKTA_ISSUER: process.env.REACT_APP_OKTA_ISSUER || '',
  OKTA_REDIRECT_END_POINT:
    process.env.REACT_APP_OKTA_REDIRECT_END_POINT || '/login/callback',
  OKTA_DISABLE_HTTPS_CHECK: process.env.REACT_APP_OKTA_DISABLE_HTTPS_CHECK,
  OKTA_ENABLE_PKCE: process.env.REACT_APP_OKTA_ENABLE_PKCE === 'true',
  /********************************************************************/

  PUBLIC_URL: process.env.PUBLIC_URL,
};

export default APP_ENV;
